<div *ngIf="isLoading">Loading Income List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="income" [(ngModel)]="model.income" [required]="required">
  <option *ngFor="let singleIncome of incomes" [ngValue]="singleIncome">{{ singleIncome.name }}</option>
</select>
